import axios from "axios";

export default axios.create({
    //baseURL: "http://localhost",
    baseURL: "",
    headers: {
        "Content-type": "application/json",
    },
});